/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var paginationDefaultProps = {
  defaultCurrent: 1,
  foldedMaxPageBtn: 5,
  maxPageBtn: 10,
  pageEllipsisMode: "mid",
  defaultPageSize: 10,
  pageSizeOptions: [5, 10, 20, 50],
  showFirstAndLastPageBtn: false,
  showJumper: false,
  showPageNumber: true,
  showPageSize: true,
  showPreviousAndNextBtn: true,
  size: "medium",
  theme: "default",
  total: 0,
  totalContent: true
};
var paginationMiniDefaultProps = {
  layout: "horizontal",
  showCurrent: true,
  size: "medium",
  variant: "text"
};

export { paginationDefaultProps, paginationMiniDefaultProps };
//# sourceMappingURL=defaultProps.js.map
